import { FC } from 'react'
import { TypeModuleTableDataCellProps } from 'Type'


const ModuleTableDataTableCellDisplayUrl :FC<TypeModuleTableDataCellProps> = ({ value } :TypeModuleTableDataCellProps) => {
    if (!value || typeof value !== 'string') return null
    return <a href={(value.includes('http://') || value.includes('https://')) ? value : `https://${value}`} target={'_blank'} rel={'noreferrer'}>{value}</a>
}

export default ModuleTableDataTableCellDisplayUrl